import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Mask = (props) => {
    const { visible, videoUrl, onClose } = props;

    return (
        <div className={styles.mask} style={{ display: visible ? 'flex' : 'none' }} id="mask1">
            <div className={styles.video_wp} id="video_wp">
                <video id="video" src={videoUrl} controls autoPlay width="100%" height="auto" preload="meta" data-setup="{}" x5-playsinline="" webkit-playsinline="" playsInline="" x-webkit-airplay="allow" />
                <div className={styles.close}>
                    <img src="https://x0.ifengimg.com/ucms/2021_34/CB5E1E455F4CF99D965377482E9FF3AC0FD608CD_size1_w45_h45.png" alt="" onClick={onClose} />
                </div>
            </div>
        </div>
    );
};

Mask.propTypes = {
    visible: PropTypes.bool,
    videoUrl: PropTypes.string,
    onClose: PropTypes.func
};

export default errorBoundary(Mask);
